import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Grid,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import ModalPolizas from './ModalPolizas';
import Swal from 'sweetalert2';
function GestionOrigenes({ origen, handleNewOrigenes, onCancel }) {
  const { tienePermiso } = useAccesos();
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;

  const [descripcion, setDescripcion] = useState('');
  const [rtn, setRtn] = useState('');
  const [empresa, setEmpresa] = useState(false); // Cambiado a booleano
  const [direccion, setDireccion] = useState('');
  const [alias, setAlias] = useState('');
  const [correo, setCorreo] = useState('');
  const [telefono, setTelefono] = useState('');
  const [celular, setCelular] = useState('');
  const [creditoAutorizado, setCreditoAutorizado] = useState(false);
  const [diasCredito, setDiasCredito] = useState(0);
  const [cuentaContable, setCuentaContable] = useState('');
  const [origenGuardado, setOrigenGuardado] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [aseguradora, setAseguradora] = useState(false);
  const [porcentajeCopago, setPorcentajeCopago] = useState(0);
  const { user } = useUser();

  // Estados para cuentas contables y clasificaciones
  const [cuentasContables, setCuentasContables] = useState([]);
  const [clasificacionesProducto, setClasificacionesProducto] = useState([]);

  // Estados para el modal y descuentos por uso
  const [openModal, setOpenModal] = useState(false);
  const [descuentosPorUso, setDescuentosPorUso] = useState([]);

  // Estado para controlar si se está editando en descuentos
  const [isEditingDescuentos, setIsEditingDescuentos] = useState(false);
  const [openPolizasModal, setOpenPolizasModal] = useState(false);
  const [polizasConfiguradas, setPolizasConfiguradas] = useState([]);

  // Función para abrir el modal de Pólizas
  const handleOpenPolizasModal = () => {
    const idOrigenValido = origen?.idOrigen || origenGuardado;

    if (!aseguradora) {
      Swal.fire({
        icon: 'info',
        title: 'Información',
        text: 'Debes marcar el campo "Aseguradora" para asignar pólizas.',
      });
      return;
    }

    if (!idOrigenValido) {
      Swal.fire({
        icon: 'warning',
        title: 'Origen no guardado',
        text: 'Debes guardar primero el origen antes de poder asignarle pólizas.',
      });
      return;
    }

    setOpenPolizasModal(true);
  };


  // Función para cerrar el modal de Pólizas
  const handleClosePolizasModal = () => {
    setOpenPolizasModal(false);
    setTimeout(() => {
      setOrigenGuardado('');
      setDescripcion('');
    }, 100); // le damos tiempo al modal de cerrar antes de limpiar
  };


  // Callback para actualizar la lista de pólizas configuradas
  const handlePolizasChange = (newPolizas) => {
    setPolizasConfiguradas(newPolizas);
  };

  // Efecto para cargar cuentas contables y clasificaciones de producto
  useEffect(() => {
    const fetchCuentasContables = async () => {
      try {
        const response = await fetch(`${server}/CntCuentasContablesDetalles`);
        const data = await response.json();
        setCuentasContables(data.$values);
      } catch (error) {
        console.error('Error al cargar las cuentas contables:', error);
      }
    };

    const fetchClasificacionesProducto = async () => {
      try {
        const response = await fetch(`${server}/IvProductosClasificacionesPorUsoes`);
        const data = await response.json();
        setClasificacionesProducto(data.$values);
      } catch (error) {
        console.error('Error al cargar las clasificaciones de producto:', error);
      }
    };

    fetchCuentasContables();
    fetchClasificacionesProducto();
  }, []);

  // Efecto para poblar los campos si estamos en modo edición
  useEffect(() => {
    if (origen) {
      setDescripcion(origen.descripcion);
      setRtn(origen.rtn);
      setEmpresa(Boolean(origen.empresa));
      setCreditoAutorizado(Boolean(origen.creditoAutorizado));
      setAseguradora(Boolean(origen.aseguradora));
      setDireccion(origen.direccion);
      setAlias(origen.alias);
      setCorreo(origen.correo);
      setTelefono(origen.telefono);
      setCelular(origen.celular);
      setDiasCredito(origen.diasCredito);
      setCuentaContable(origen.idCuentaContable);
      setPorcentajeCopago(origen.porcentajeCopago);
      setIsEditing(true);
      // Cargar descuentos existentes
      fetchDescuentosPorUso(origen.idOrigen);
    }
  }, [origen]);

  // Función para cargar descuentos existentes
  const fetchDescuentosPorUso = async (idOrigen) => {
    try {
      console.log(idOrigen);

      const response = await fetch(
        `${server}/mg_origen_empresa_descuento_por_uso/byidorigen/${idOrigen}`
      );
      const data = await response.json();
      console.log(data.$values);
      // Si data es un array, se utiliza tal cual; de lo contrario, se envuelve en un array
      const descuentos = Array.isArray(data) ? data : data ? [data] : [];
      setDescuentosPorUso(data.$values);
      console.log(descuentos);
    } catch (error) {
      console.error('Error al cargar los descuentos por uso:', error);
    }
  };


  // Funciones para el manejo del modal de descuentos
  const handleOpenModal = () => {
    setOpenModal(true);
    setIsEditingDescuentos(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setIsEditingDescuentos(false);
  };

  // Funciones para manejar la tabla de descuentos
  const handleAgregarFila = () => {
    setDescuentosPorUso([
      ...descuentosPorUso,
      {
        id: null, // Indica que es una nueva fila
        id_Clasificacion_Producto: '',
        descuento: 0,
        descuento_remitido: 0,
        isNew: true, // Marca para identificar filas nuevas
      },
    ]);
  };

  const handleChangeFila = (index, field, value) => {
    const nuevosDescuentos = [...descuentosPorUso];

    // Asegurarse de que el objeto en ese índice exista
    if (!nuevosDescuentos[index]) {
      nuevosDescuentos[index] = {
        id_Clasificacion_Producto: clasificacionesProducto[index]?.id,
        descuento: '',
        descuento_remitido: '',
        isNew: true,
      };
    }

    // Validación para campos numéricos (rango 1-100)
    if ((field === 'descuento' || field === 'descuento_remitido') && value !== '') {
      const numero = parseFloat(value);
      if (numero < 1 || numero > 100) return; // ignora si no está en el rango
    }

    nuevosDescuentos[index][field] = value;
    setDescuentosPorUso(nuevosDescuentos);
  };


  const handleEliminarFila = (index) => {
    const nuevosDescuentos = [...descuentosPorUso];
    nuevosDescuentos.splice(index, 1);
    setDescuentosPorUso(nuevosDescuentos);
  };


  useEffect(() => {
    if (openModal) {
      const inicializarDescuentos = clasificacionesProducto.map(clas => {
        const existente = descuentosPorUso.find(d => d.id_Clasificacion_Producto === clas.id);
        return existente || {
          id_Clasificacion_Producto: clas.id,
          descuento: '',
          descuento_remitido: '',
          isNew: true,
        };
      });
      setDescuentosPorUso(inicializarDescuentos);
    }
  }, [openModal, clasificacionesProducto]);

  // Función para guardar el origen y los descuentos
  const handleSubmit = async (e) => {
    e.preventDefault();

    const nuevoOrigen = {
      idOrigen: origen ? origen.idOrigen : 0,
      descripcion,
      rtn,
      empresa: empresa ? 1 : 0,
      direccion,
      alias,
      correo,
      telefono,
      celular,
      creditoAutorizado: creditoAutorizado ? true : false,
      diasCredito: diasCredito,
      idCuentaContable: cuentaContable ? cuentaContable : 0,
      aseguradora: aseguradora ? true : false,
      porcentajeCopago: porcentajeCopago,
      ...(origen
        ? { modificadoPor: user ? user.codigoUsuario : 'ADMIN' } // Si es edición
        : { ingresadoPor: user ? user.codigoUsuario : 'ADMIN' }),
    };

    console.log(nuevoOrigen);

    try {
      const response = await fetch(
        `${server}/MgOrigenes${origen ? '/' + origen.idOrigen : ''}`,
        {
          method: origen ? 'PUT' : 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(nuevoOrigen),
        }
      );

      if (response.ok) {
        console.log('Response:', response);
        let data;
        let idOrigenGuardado;
        if (origen === null) {
          data = await response.json();
          console.log(data);
          idOrigenGuardado = data.idOrigen;
        } else {
          idOrigenGuardado = origen.idOrigen;
        }
        setOrigenGuardado(idOrigenGuardado);
        console.log(descuentosPorUso);
        // Guardar los descuentos por uso
        for (const descuento of descuentosPorUso) {
          if (descuento.isNew || descuento.id === null) {
            console.log('Entro al if');
            const descuentoData = {
              id_origen: idOrigenGuardado,
              id_Clasificacion_Producto: descuento.id_Clasificacion_Producto,
              descuento: parseFloat(descuento.descuento),
              descuento_remitido: parseFloat(descuento.descuento_remitido),
              ingresadoPor: user ? user.codigoUsuario : 'ADMIN',
              fechaIngreso: new Date().toISOString(),
            };
            console.log(descuentoData);
            await fetch(`${server}/mg_origen_empresa_descuento_por_uso`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(descuentoData),
            });
          } else {
            const descuentoData = {
              id: descuento.id,
              id_origen: idOrigenGuardado,
              id_Clasificacion_Producto: descuento.id_Clasificacion_Producto,
              descuento: parseFloat(descuento.descuento),
              descuento_remitido: parseFloat(descuento.descuento_remitido),
              modificadoPor: user ? user.codigoUsuario : 'ADMIN',
              fechaModificacion: new Date().toISOString(),
            };
            console.log(descuentoData);
            await fetch(`${server}/mg_origen_empresa_descuento_por_uso/${descuento.id}`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(descuentoData),
            });
          }
        }

        if (!aseguradora) {
          limpiarFormulario();
        }

        handleNewOrigenes();
        Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: origen ? 'Origen actualizado con éxito' : 'Origen creado con éxito',
          timer: 2000,
          showConfirmButton: false
        });


      } else {

        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: origen ? 'Error al actualizar el origen.' : 'Error al crear el origen.',
          timer: 2000,
          showConfirmButton: false
        });


      }
    } catch (error) {
      console.error('Error al guardar el origen:', error);
      alert('Error al guardar el origen');
    }
  };

  // Estilos para el modal
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxHeight: '90vh',
    overflowY: 'auto',
    backgroundColor: '#fff',
    padding: '20px',
    boxShadow: 24,
    outline: 'none',
  };

  const limpiarFormulario = () => {
    setDescripcion('');
    setRtn('');
    setEmpresa(false);
    setDireccion('');
    setAlias('');
    setCorreo('');
    setTelefono('');
    setCelular('');
    setCreditoAutorizado(false);
    setDiasCredito(0);
    setCuentaContable('');
    setAseguradora(false);
    setPorcentajeCopago(0);
    setDescuentosPorUso([]);
  };

  // Función para cancelar la actualización
  const handleCancel = () => {
    if (onCancel) {
      onCancel(); // Llama a la función onCancel pasada desde el componente padre
    } else {
      // Si no se proporciona onCancel, restablece los campos del formulario
      setDescripcion('');
      setRtn('');
      setEmpresa(false);
      setDireccion('');
      setAlias('');
      setCorreo('');
      setTelefono('');
      setCelular('');
      setCreditoAutorizado(false);
      setDiasCredito(0);
      setCuentaContable('');
      setAseguradora(false);
      setPorcentajeCopago(0);
      setDescuentosPorUso([]);
      setIsEditing(false);
    }
  };

  return (
    <>
      <form id="formOrigen" className="form-horizontal form-label-left" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* Información de la Empresa */}
          <Grid item xs={12}>
            <h2>Información de la Empresa</h2>
          </Grid>

          {/* Descripción */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Descripción"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
            />
          </Grid>

          {/* Alias */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Alias"
              value={alias}
              onChange={(e) => setAlias(e.target.value)}
            />
          </Grid>

          {/* RTN */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="RTN"
              value={rtn}
              onChange={(e) => setRtn(e.target.value)}
            />
          </Grid>

          {/* Dirección */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Dirección"
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
            />
          </Grid>

          {/* Correo */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Correo"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
            />
          </Grid>

          {/* Teléfono */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Teléfono"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
            />
          </Grid>

          {/* Celular */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Celular"
              value={celular}
              onChange={(e) => setCelular(e.target.value)}
            />
          </Grid>

          {/* Empresa */}
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox checked={empresa} onChange={(e) => setEmpresa(e.target.checked)} />
              }
              label="Empresa"
            />
          </Grid>

          {/* Información Financiera */}
          <Grid item xs={12}>
            <h2>Información Financiera</h2>
          </Grid>

          {/* Crédito Autorizado */}
          <Grid item xs={12} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={creditoAutorizado}
                  onChange={(e) => setCreditoAutorizado(e.target.checked)}
                />
              }
              label="Crédito Autorizado"
            />
          </Grid>

          {/* Días de Crédito */}
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Días de Crédito"
              type="number"
              value={diasCredito}
              disabled={!creditoAutorizado}
              onChange={(e) => setDiasCredito(parseInt(e.target.value, 10))}
            />
          </Grid>

          {/* Cuenta Contable */}
          <Grid item xs={12} md={4}>
            <Autocomplete
              options={cuentasContables}
              getOptionLabel={(option) => `${option.codigo} ${option.descripcion}` || ''}
              value={cuentasContables.find((c) => c.id === cuentaContable) || null}
              onChange={(event, newValue) => setCuentaContable(newValue ? newValue.id : '')}
              renderInput={(params) => <TextField {...params} label="Cuenta Contable" fullWidth />}
              required
            />
          </Grid>

          {/* Información Adicional */}
          <Grid item xs={12}>
            <h2>Información Adicional</h2>
          </Grid>

          {/* Aseguradora */}
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={aseguradora}
                  onChange={(e) => setAseguradora(e.target.checked)}
                />
              }
              label="Aseguradora"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenPolizasModal}
              style={{ marginLeft: '10px' }}
            >
              Pólizas
            </Button>
          </Grid>

          {/* Porcentaje Copago */}
          {/* <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Porcentaje Copago"
              type="number"
              value={porcentajeCopago}
              onChange={(e) => setPorcentajeCopago(parseFloat(e.target.value))}
            />
          </Grid> */}

          {/* Botón para abrir el modal de Descuentos por Uso */}
          <Grid item xs={12} md={6}>
            <Button variant="contained" color="primary" onClick={handleOpenModal} disabled={!tienePermiso('Gestionar Descuentos Origen')}>
              Gestionar Descuentos por Uso
            </Button>
          </Grid>

          {/* Botón para guardar */}
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" disabled={!tienePermiso('Crear Origen')}>
              {isEditing ? 'Actualizar' : 'Crear'} Origen
            </Button>
            {isEditing && (
              <Button variant="contained" color="secondary" onClick={handleCancel} style={{ marginLeft: '10px' }}>
                Cancelar
              </Button>
            )}
          </Grid>
        </Grid>
      </form>

      {/* Modal para gestionar descuentos por uso */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <div style={modalStyle}>
          <h2>Descuentos por Uso</h2>
          <TableContainer component={Paper} style={{ maxHeight: 400 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Clasificación Producto</TableCell>
                  <TableCell>Descuento (%)</TableCell>
                  <TableCell>Descuento Remitido (%)</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clasificacionesProducto.map((clasificacion, index) => {
                  const descuento = descuentosPorUso.find(d => d.id_Clasificacion_Producto === clasificacion.id) || {};
                  return (
                    <TableRow key={clasificacion.id}>
                      <TableCell>{clasificacion.descripcion}</TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          inputProps={{ min: 1, max: 100 }}
                          value={descuento.descuento || 0}
                          onChange={(e) => {
                            const value = e.target.value;
                            const num = Number(value);
                            if (value === '' || (num >= 1 && num <= 100)) {
                              handleChangeFila(index, 'descuento', value);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          inputProps={{ min: 0, max: 100 }}
                          value={descuento.descuento_remitido || 0}
                          onChange={(e) => {
                            const value = e.target.value;
                            const num = Number(value);
                            if (value === '' || (num >= 1 && num <= 100)) {
                              handleChangeFila(index, 'descuento_remitido', value);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleEliminarFila(index)}
                        >
                          Eliminar
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid container spacing={2} justifyContent="flex-end" style={{ marginTop: 10 }}>
            <Grid item>
              <Button variant="contained" color="secondary" onClick={handleCloseModal}>
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </div>
      </Modal>


      <ModalPolizas
        open={openPolizasModal}
        onClose={handleClosePolizasModal}
        clasificacionesProducto={clasificacionesProducto}
        onPolizasChange={handlePolizasChange}
        initialPolizas={polizasConfiguradas}
        idOrigen={origenGuardado || (origen ? origen.idOrigen : null)}
        descripcionOrigen={origenGuardado ? descripcion : (origen ? origen.descripcion : '')}
      />

    </>
  );
}

export default GestionOrigenes;
